import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  image: string;
  rating: number;
  category: string;
  year: number;
  isNew?: boolean;
}

export default function MovieCard({ id, title, image, rating, category, year, isNew }: MovieCardProps) {
  const categoryLabels: Record<string, string> = {
    dianying: "电影",
    dianshiju: "电视剧",
    dongman: "动漫",
    zongyi: "综艺",
  };

  return (
    <Link
      to={`/movie/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1.5 flex-wrap">
          <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            {rating}
          </span>
          {isNew && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
              NEW
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3 pt-8">
          <span className="text-xs text-white/70">{categoryLabels[category] || category} · {year}</span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
        {title}
      </h3>
    </Link>
  );
}